import { DIST_EPSILON } from "./core";
import { polyLine2EdgeCount, polyLine2Vertex } from "./polyLine2";
import type { PolyLine2 } from "./polyLine2Types";
import { vec2AngleBetween, vec2Rotate } from "./vec2";

/**
 * Finds the min and max intersections of a PolyLine2 in a given orientation.
 */
export function polyLine2MinMaxIndices(
  pl: PolyLine2,
  oX: number,
  oY: number,
  tolerance: number = DIST_EPSILON,
): { min: number[]; max: number[] } {
  const numEdges = polyLine2EdgeCount(pl);

  let min = 0;
  let max = 0;

  let minIndices: number[] = [];
  let maxIndices: number[] = [];

  // angle between orientation and X axis
  const angle = vec2AngleBetween(1, 0, oX, oY);

  for (let i = 0; i < numEdges; i++) {
    const [vx, vy] = polyLine2Vertex(pl, i);

    // rotate this point to align to the target vector
    const [test] = vec2Rotate(vx, vy, -angle);

    if (minIndices.length === 0) {
      min = test;
      minIndices.push(i);
    } else {
      const minCheck = test + tolerance;
      if (minCheck < min) {
        min = test;
        minIndices = [i];
      } else if (Math.abs(test - min) < tolerance) {
        minIndices.push(i);
      }
    }

    if (maxIndices.length === 0) {
      max = test;
      maxIndices.push(i);
    } else {
      const maxCheck = test - tolerance;
      if (maxCheck > max) {
        max = test;
        maxIndices = [i];
      } else if (Math.abs(test - max) < tolerance) {
        maxIndices.push(i);
      }
    }
  }

  return { min: minIndices, max: maxIndices };
}
